import { render, staticRenderFns } from "./DeleteItemDialog.vue?vue&type=template&id=7240ff7b&scoped=true&"
import script from "./DeleteItemDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteItemDialog.vue?vue&type=style&index=0&id=7240ff7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7240ff7b",
  null
  
)

export default component.exports